import type { ShippingFormFields, TelephoneFieldValue } from "@jti/commerce-types";

import type {
  AddressCustomShippingFieldConfig,
  FirstNameFieldConfig,
  LastNameFieldConfig,
  ShouldUseProfileDataFieldConfig,
} from "@checkout-v2/formFields";
import type { AddressHomeDeliveryFieldConfig } from "@checkout-v2/formFields/factories/addressHomeDeliveryFieldFactory";
import type { AddressInStoreDeliveryFieldConfig } from "@checkout-v2/formFields/factories/addressInStoreDeliveryFactory";
import type { BillingAddressFieldConfig } from "@checkout-v2/formFields/factories/billingAddressFieldFactory";
import type { DeliveryOptionsFactoryDerivedConfig } from "@checkout-v2/formFields/factories/deliveryOptionsFactory";
import type { IsBillingAddressSameAsShippingFieldConfig } from "@checkout-v2/formFields/factories/isBillingAddressSameAsShippingFieldFactory";
import type { ShippingMethodCodeFieldConfig } from "@checkout-v2/formFields/factories/shippingMethodCodeFieldFactory";
import type { TelephoneFieldConfig } from "@checkout-v2/formFields/factories/telephoneFieldFactory/telephoneFieldFactory";

export type ShippingFormFieldsNames = keyof ShippingFormFields;

export type ShippingFormFieldsDefaultValues = ShippingFormFields & {
  telephoneFallback: TelephoneFieldValue;
};

export type ShippingFormFieldsConfig = {
  telephone: TelephoneFieldConfig;
  shouldUseProfileData: ShouldUseProfileDataFieldConfig;
  firstName: FirstNameFieldConfig;
  lastName: LastNameFieldConfig;
  shippingMethodCode: ShippingMethodCodeFieldConfig;
  addressInStoreDelivery: AddressInStoreDeliveryFieldConfig;
  addressHomeDelivery: AddressHomeDeliveryFieldConfig;
  addressCustomShipping: AddressCustomShippingFieldConfig;
  isBillingAddressSameAsShipping: IsBillingAddressSameAsShippingFieldConfig;
  billingAddress: BillingAddressFieldConfig;
  deliveryOption: DeliveryOptionsFactoryDerivedConfig;
};
